import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { GuardsModule } from '@app/src/app/guards';

import { PeopleSelectorModule } from './people-selector.module';
import { getPeopleSelectorRoutes } from './utils';

@NgModule({
  imports: [GuardsModule, RouterModule.forChild(getPeopleSelectorRoutes()), PeopleSelectorModule],
  // providers: [
  //   {
  //     provide: PEOPLE_SELECTOR_FORMS.Tickets.injectionToken,
  //     useClass: PEOPLE_SELECTOR_FORMS.Tickets.service,
  //   },
  // ],
  exports: [RouterModule],
})
export class PeopleSelectorRoutesModule {}
